import React from 'react';
import Header from './components/Headers';
import Home from './components/Home';
import About from './components/About';
import CarRental from './components/CarRental';
import TourPackages from './components/TourPackages';
import Contact from './components/Contact';
import Footer from './components/Footer';


import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      {/* <TopBar />
      <Navigation /> */}
      <main>
        <section id="home">
          <Home />
        </section>

        <section id="about" className="about-section">
          <About />
        </section>

        {/* <section id="vehicles">
          <Vehicles />
        </section> */}

        <section id="car-rental" className="car-rental-section">
          <CarRental />
        </section>
          
        <section id="tour-packages" className='tour-section'>
          <TourPackages />
        </section>
        { /*
        <section id="gallery">
          Gallery Section
        </section>*/}

        <section id="contact" className="contact-section">
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
